/**
 * @generated SignedSource<<56b68970d66a9acdd7021d1908529c78>>
 * @relayHash a4f12fad1060649648014071a0eb0bd8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a4f12fad1060649648014071a0eb0bd8

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Law = "IVG" | "KVG" | "MVG" | "ORG" | "UVG" | "VVG";
export type NotBillableReason = "ADMINISTRATIVE" | "INCOMPLETE_CONSULTATION" | "OTHER_REASON";
export type TreatmentReason = "ACCIDENT" | "CONGENITAL_DEFECT" | "MATERNITY" | "PREVENTION" | "SICKNESS";
export type EditBillingAttributesInput = {
  accidentReference?: string | null;
  appointmentId: string;
  currentGestationWeek?: number | null;
  dateOfAccident?: any | null;
  isEmployer?: boolean | null;
  isNotBillable: boolean;
  isPatientPregnant?: boolean | null;
  isVisualSymptomExamination?: boolean | null;
  ivgCaseReference?: string | null;
  lawType?: Law | null;
  mvgCaseReference?: string | null;
  notBillableReason?: NotBillableReason | null;
  organisationId?: string | null;
  reason?: string | null;
  treatmentReason?: TreatmentReason | null;
};
export type useEditBillingAttributesMutation$variables = {
  input: EditBillingAttributesInput;
};
export type useEditBillingAttributesMutation$data = {
  readonly editBillingAttributes: {
    readonly billingAttribute: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"BillingAttributeFragment">;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useEditBillingAttributesMutation = {
  response: useEditBillingAttributesMutation$data;
  variables: useEditBillingAttributesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEditBillingAttributesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EditBillingAttributesPayload",
        "kind": "LinkedField",
        "name": "editBillingAttributes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAttribute",
            "kind": "LinkedField",
            "name": "billingAttribute",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BillingAttributeFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useEditBillingAttributesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EditBillingAttributesPayload",
        "kind": "LinkedField",
        "name": "editBillingAttributes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAttribute",
            "kind": "LinkedField",
            "name": "billingAttribute",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNotBillable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notBillableReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "treatmentReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVisualSymptomExamination",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentGestationWeek",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "organisationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateOfAccident",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accidentReference",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEmployer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lawType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ivgCaseReference",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mvgCaseReference",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a4f12fad1060649648014071a0eb0bd8",
    "metadata": {},
    "name": "useEditBillingAttributesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cf2cda39e084e1cde7a3419e69d7738c";

export default node;
